import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { GridColDef, DataGrid } from '@mui/x-data-grid';
import './OldDocumentsTable.scss';
import { DocumentDetails } from '../../../../slices/marketplace/timeline/models/document-details.model';
import moment from 'moment';

interface OldDocumentsTableProps {
    oldDocumentDetailsList: DocumentDetails[];
    downloadDocument: (documentId: string) => void;
}

const OldDocumentsTable = (props: OldDocumentsTableProps) => {
    const columns: GridColDef[] = [
        {
            field: 'fileName',
            headerName: 'Name',
            flex: 2,
            minWidth: 100,
            editable: false,
            resizable: false,
            renderCell: (params: any) => {
                return (
                    <a
                        className="link-button"
                        onClick={() => props.downloadDocument(params.row.id)}>
                        {params.row.fileName.replace(/(_\d+)(\.[^.]+)$/, '$2')}
                    </a>
                );
            },
        },
        {
            field: 'datePosted',
            headerName: 'Date Posted',
            flex: 2,
            minWidth: 100,
            editable: false,
            resizable: false,
            valueFormatter: (params: Date) =>
                moment(params).format('l hh:mm A'),
        },
    ];

    const additionalStyles = {
        border: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '.MuiDataGrid-scrollbar': {
            display: 'none',
        },
        '.MuiDataGrid-row': {
            borderBottom: 'none',
        },
        '.MuiDataGrid-columnHeader:focus': {
            outline: 'none',
        },
        '.MuiDataGrid-cell:focus': {
            outline: 'none',
        },
    };

    return (
        <Box
            sx={{ width: '100%', overflow: 'auto', scrollbarWidth: 'none' }}
            className="old-documents-table">
            <DataGrid
                disableColumnMenu
                disableColumnFilter
                disableColumnSelector
                disableColumnResize
                sx={additionalStyles}
                columns={columns}
                rows={props.oldDocumentDetailsList}
                loading={false}
            />
        </Box>
    );
};

export default OldDocumentsTable;
